import styled from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

export const PlateListContainer = styled.section`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-top: ${(props) => props.marginTop ?? "0px"};
  margin-bottom: ${(props) => props.marginTop ?? "0px"};
  justify-content: ${(props) =>
    props?.content ? props.content : "space-between"};
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  max-height: 6rem;
  overflow-y: scroll;
`;

export const GridRowTitle = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: ${(props) => (props?.gap ? props.gap : "1rem")};
`;

export const ContactButton = styled(BaseButton)`
  border: 1px solid ${(props) => props.background};
  background: ${(props) => props.border};
  font-weight: normal;
  width: ${(props) => props.width ?? "auto"};
  margin-right: ${(props) => props.marginRight ?? "0px"};
  margin-left: ${(props) => props.marginLeft ?? "0px"};
  margin-top: ${(props) => props.marginTop ?? "0px"};
  float: ${(props) => props.float ?? "none"};
  height: ${(props) => props.height ?? "auto"};
  margin-bottom: 0px;
  padding: 3px 7px 0px;
`;

export const PlateText = styled.span`
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  font-size: 16px;
  line-height: 25px;
  font-weight: 700;
  color: #fff;
`;

export const Title = styled.h2`
  color: #0a4986;
  font-size: 16px;
  font-family: lato;
  text-transform: initial;
  margin: 0px;
  padding: 0px 0px 3px 0px;
  justify-self: auto;
  font-weight: bold !important;
`;
